import React from 'react';
import { Route, Routes } from 'react-router-dom';
import AppShell from '../layouts/AppShell';
import V2ScrollToTop from '../layouts/V2ScrollToTop';
import RequireAuth from '../layouts/RequireAuth';
import Landing from '../pages/Landing';
import Auth from '../pages/Auth';
import Catalog from '../pages/Catalog';
import Categories from '../pages/Categories';
import ProductDetail from '../pages/ProductDetail';
import Cart from '../pages/Cart';
import Checkout from '../pages/Checkout';
import CheckoutSummary from '../pages/CheckoutSummary';
import CheckoutPay from '../pages/CheckoutPay';
import OrderStatus from '../pages/OrderStatus';
import Account from '../pages/Account';
import OrderDetails from '../pages/OrderDetails';
import LocationPage from '../pages/LocationPage';
import Coupon from '../pages/Coupon';
import ContactUs from '../pages/ContactUs';
import TermsAndConditions from '../pages/TermsAndConditions';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import RefundPolicy from '../pages/RefundPolicy';

export default function V2Routes() {
  return (
    <AppShell>
      <V2ScrollToTop />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/categories" element={<Categories />} />
        <Route path="/catalog" element={<Catalog />} />
        <Route path="/catalog/:id" element={<ProductDetail />} />
        <Route path="/cart" element={<Cart />} />
        <Route
          path="/checkout/summary"
          element={
            <RequireAuth>
              <CheckoutSummary />
            </RequireAuth>
          }
        />
        <Route
          path="/checkout/pay"
          element={
            <RequireAuth>
              <CheckoutPay />
            </RequireAuth>
          }
        />
        <Route
          path="/order-status"
          element={
            <RequireAuth>
              <OrderStatus />
            </RequireAuth>
          }
        />
        <Route
          path="/checkout"
          element={
            <RequireAuth>
              <Checkout />
            </RequireAuth>
          }
        />
        <Route
          path="/account/orders/:orderId"
          element={
            <RequireAuth>
              <OrderDetails />
            </RequireAuth>
          }
        />
        <Route
          path="/account"
          element={
            <RequireAuth>
              <Account />
            </RequireAuth>
          }
        />
        <Route path="/location" element={<LocationPage />} />
        <Route path="/coupon" element={<Coupon />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/refund" element={<RefundPolicy />} />
      </Routes>
    </AppShell>
  );
}
